"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _isEmpty = _interopRequireDefault(require("../utils/isEmpty"));

var _RouterContext = require("../RouterContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function addScope(routerState, scope, scopedState) {
  return scopedState && _objectSpread(_objectSpread({}, routerState), {}, {
    [scope]: scopedState
  });
}

class RouteScope extends _react.default.Component {
  constructor(props, context) {
    super(props);

    _defineProperty(this, "context", null);

    _defineProperty(this, "__internalRouter", void 0);

    _defineProperty(this, "getScopedState", () => {
      var scope = this.props.scope;
      if (!this.context) throw new Error('RouteScope: missing context value');
      var parentInternalRouter = this.context.__internalRouter;
      return parentInternalRouter.getState()[scope];
    });

    _defineProperty(this, "resolvePathFromState", nextState => {
      if (!this.context) throw new Error('RouteScope: missing context value');
      var parentInternalRouter = this.context.__internalRouter;
      var scope = this.props.scope;
      var nextStateScoped = (0, _isEmpty.default)(nextState) ? {} : addScope(parentInternalRouter.getState(), scope, nextState);
      return parentInternalRouter.resolvePathFromState(nextStateScoped);
    });

    _defineProperty(this, "navigate", (nextState, options) => {
      if (!this.context) throw new Error('RouteScope: missing context value');
      var parentInternalRouter = this.context.__internalRouter;
      var nextScopedState = addScope(parentInternalRouter.getState(), this.props.scope, nextState);
      parentInternalRouter.navigate(nextScopedState, options);
    });

    var _parentInternalRouter = context.__internalRouter;
    this.__internalRouter = _objectSpread(_objectSpread({}, _parentInternalRouter), {}, {
      resolvePathFromState: this.resolvePathFromState,
      navigate: this.navigate,
      getState: this.getScopedState
    });
  }

  getChildContext() {
    return {
      __internalRouter: this.__internalRouter
    };
  }

  render() {
    return /*#__PURE__*/_react.default.createElement(_RouterContext.RouterContext.Provider, {
      value: this.__internalRouter
    }, this.props.children);
  }

}

exports.default = RouteScope;

_defineProperty(RouteScope, "childContextTypes", {
  __internalRouter: _propTypes.default.object
});

_defineProperty(RouteScope, "contextTypes", {
  __internalRouter: _propTypes.default.object
});